
import ArrowLeft from "../../../assets/outline/ArrowLeft.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowLeftIcon({ className, dataTestid = "ArrowLeftIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowLeft data-testid={dataTestid} className={classes} {...rest} />
  );
}
